import { render, staticRenderFns } from "./dealHistory.vue?vue&type=template&id=6dc5939d&scoped=true"
import script from "./dealHistory.vue?vue&type=script&lang=js"
export * from "./dealHistory.vue?vue&type=script&lang=js"
import style0 from "./dealHistory.vue?vue&type=style&index=0&id=6dc5939d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5939d",
  null
  
)

export default component.exports